import React from "react";
import { List, ListItem } from "@chakra-ui/react";
import { useLocation } from "react-router-dom"; // Import useLocation to get current route
import {
  MdOutlineSpaceDashboard,
  MdOutlineShoppingBag,
  MdMailOutline,
  MdOutlinePeople,
  MdOutlineNotificationsActive,
  MdOutlineChatBubbleOutline,
  MdOutlineSettingsInputComposite,
  MdOutlineInfo,
  MdOutlineCategory,
  MdFitnessCenter,
  MdFastfood,
  MdOutlineDirectionsRun,
  MdOutlineVideoLibrary,
  MdOutlineCalendarToday,
  MdOutlineHome,
  MdOutlineTimer,
  MdOutlineViewModule,
  MdOutlineNewReleases,
  MdOutlineStopCircle,
  MdOutlineFileUpload,
  MdOutlineAssessment,
} from "react-icons/md";

import { NavItem } from "./NavItem";
import { Path } from "../../lib/constants/path.constants";

// Define the nav items
const items: NavbarItem[] = [
  {
    type: "link",
    label: "Dashboard",
    icon: MdOutlineSpaceDashboard,
    path: Path.DASHBOARD,
  },
   {
    type: "link",
    label: "Home",
    icon: MdOutlineHome,
    path: Path.HOMES,
  },
  {
    type: "group",
    label: "Users",
    icon: MdOutlinePeople,
    children: [
      {
        type: "link",
        label: "User List",
        icon: MdOutlinePeople,
        path: Path.USERS,
      },
      {
        type: "link",
        label: "Bulk Migration",
        icon: MdOutlineFileUpload,
        path: Path.BULK_MIGRATION,
      },
      {
        type: "link",
        label: "Program Access",
        icon: MdOutlineAssessment,
        path: Path.PROGRAM_ACCESS_REPORT,
      },
    ],
  },
  {
    type: "group",
    label: "Programs",
    icon: MdOutlineInfo,
    children: [
      {
        type: "link",
        label: "Program Builder",
        icon: MdOutlineInfo,
        path: Path.PROGRAM_INFO,
      },
      {
        type: "link",
        label: "End Pages",
        icon: MdOutlineStopCircle,
        path: Path.END_PAGES,
      },
    ],
  },
  {
    type: "link",
    label: "Warmups",
    icon: MdOutlineTimer,
    path: Path.WARMUPS,
  },
  // {
  //   type: 'link',
  //   label: 'Workouts',
  //   icon: MdOutlineCalendarToday,
  //   path: Path.WORKOUTS,
  // },
  {
    type: "link",
    label: "Exercises",
    icon: MdOutlineDirectionsRun,
    path: Path.EXERCISES,
  },
  {
    type: "link",
    label: "Categories",
    icon: MdOutlineCategory,
    path: Path.CATEGORIES,
  },
  {
    type: "link",
    label: "Equipment",
    icon: MdFitnessCenter,
    path: Path.EQUIPMENTS,
  },
  {
    type: "link",
    label: "Resources",
    icon: MdFastfood,
    path: Path.RESOURCES,
  },
  // {
  //   type: "link",
  //   label: "Videos",
  //   icon: MdOutlineVideoLibrary,
  //   path: Path.VIDEOS,
  // },
  {
    type: "link",
    label: "Rest Days",
    icon: MdOutlineVideoLibrary,
    path: Path.REST_DAYS,
  },
  {
    type: "group",
    label: "Modals",
    icon: MdOutlineViewModule,
    children: [
      {
        type: "link",
        label: "New Version",
        icon: MdOutlineNewReleases,
        path: Path.NEW_VERSION,
      },
      {
        type: "link",
        label: "Program Intros",
        icon: MdOutlineInfo,
        path: Path.PROGRAM_INTROS,
      },
      {
        type: "link",
        label: "Home Intros",
        icon: MdOutlineInfo,
        path: Path.HOME_INTROS,
      },
    ],
  },

  // { type: 'link', label: 'Reports', icon: MdMailOutline, path: '/reports' },
  // {
  //   type: 'link',
  //   label: 'Settings',
  //   icon: MdOutlineSettingsInputComposite,
  //   path: '/settings',
  // },
];

interface NavigationProps {
  collapse: boolean;
}

export const Navigation = ({ collapse }: NavigationProps) => {
  const location = useLocation();

  return (
    <List w="full" my={8}>
      {items.map((item, index) => (
        <ListItem key={index}>
          <NavItem
            item={item}
            isActive={location.pathname === item.path}
            collapse={collapse}
          />
        </ListItem>
      ))}
    </List>
  );
};
